<template>
  <loading :active="isLoading" :is-full-page="fullPage" :color="color" :enforce-focus="enforceFocus" class="app-loader">
    <template v-slot:[`after`]>
      <div v-if="text" v-html="text" :class="textCss"></div>
      <div v-if="showProgress" class="app-loader-progress-container">
        <v-progress-linear v-model="progress" :height="15">
          <div v-if="showProgressTotal">{{ progressValue }} / {{ progressTotal }}</div>
          <div v-else>{{ progress }}%</div>
        </v-progress-linear>
      </div>
      <div v-if="cancelCallback">
        <v-btn color="warning" text class="font-weight-bold" @click="onCancel">{{ $t('buttons.cancel') }}</v-btn>
      </div>
    </template>
  </loading>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'AppLoading',
  components: { Loading },
  props: {
    fullPage: { type: Boolean, default: true }
  },
  data() {
    return {
      isLoading: true,
      enforceFocus: false,
      color: '',
      textCss: 'text-center font-weight-bold',
      text: '',
      showProgress: false,
      showProgressTotal: false,
      progressValue: 0,
      progressTotal: 100,
      cancelCallback: null
    };
  },
  computed: {
    progress() {
      return Math.ceil(this.progressValue / this.progressTotal * 100);
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.enforceFocus = !document.getElementsByClassName('app-loader').length;
      this.color = this.$vuetify.theme['isDark']
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary;
    },
    setProgress(progressOpts) {
      if (progressOpts) {
        if ('showTotal' in progressOpts) {
          this.showProgressTotal = !!progressOpts.showTotal;
        }
        if ('total' in progressOpts) {
          this.progressTotal = progressOpts.total;
        }
        this.progressValue = progressOpts.current;
        this.showProgress = true;
      }
    },
    setText(textOpts) {
      let opts = textOpts || {};
      if ('class' in opts) {
        this.textCss = opts.class;
      }
      this.text = textOpts.text || '';
    },
    hideProgress() {
      this.showProgress = false;
    },
    onCancel() {
      if (this.cancelCallback) {
        this.cancelCallback();
      }
    },
    setCancelCallback(cancelCallback) {
      this.cancelCallback = cancelCallback;
    }
  }
};
</script>

<style>
.app-loader-progress-container {
  min-width: 150px;
}
</style>
